import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "user-form profile-form" }
const _hoisted_4 = { class: "row h2" }
const _hoisted_5 = { class: "col-md-6 col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-inboxes-fill" }, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-end col-md-6 col-sm-12" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)
const _hoisted_10 = { class: "setting-data" }
const _hoisted_11 = { class: "row align-items-center" }
const _hoisted_12 = { class: "col-md-6 col-sm-12 mb-0" }
const _hoisted_13 = { class: "col-md-6 col-sm-12 d-flex justify-content-end" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "table" }
const _hoisted_16 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none"
}
const _hoisted_17 = { class: "d-block my-3" }
const _hoisted_18 = { class: "d-none d-md-block" }
const _hoisted_19 = { class: "d-none t-d-md-table-cell" }
const _hoisted_20 = { class: "d-none t-d-md-table-cell" }
const _hoisted_21 = { class: "d-none t-d-md-table-cell" }
const _hoisted_22 = { class: "d-none t-d-md-table-cell" }
const _hoisted_23 = { class: "d-none t-d-md-table-cell" }
const _hoisted_24 = { class: "d-none t-d-md-table-cell" }
const _hoisted_25 = { class: "d-none t-d-md-table-cell" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { colspan: "8" }
const _hoisted_28 = { class: "text-center py-2" }
const _hoisted_29 = {
  "show-md": "",
  "show-lg": "",
  "hide-sm": "",
  "hide-xs": "",
  class: "d-none d-md-block"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1)
const _hoisted_32 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none",
  style: {"position":"relative"}
}
const _hoisted_33 = { style: {"padding":"5px 0"} }
const _hoisted_34 = { class: "bold" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1)
const _hoisted_37 = { style: {"padding":"5px 0"} }
const _hoisted_38 = { class: "bold" }
const _hoisted_39 = { style: {"padding":"5px 0"} }
const _hoisted_40 = { class: "bold" }
const _hoisted_41 = { style: {"padding":"5px 0"} }
const _hoisted_42 = { class: "bold" }
const _hoisted_43 = { style: {"padding":"5px 0"} }
const _hoisted_44 = { class: "bold" }
const _hoisted_45 = { style: {"padding":"5px 0"} }
const _hoisted_46 = { class: "bold" }
const _hoisted_47 = { style: {"padding":"5px 0"} }
const _hoisted_48 = { class: "bold" }
const _hoisted_49 = { style: {"padding":"5px 0"} }
const _hoisted_50 = { class: "bold" }
const _hoisted_51 = { class: "d-none t-d-md-table-cell" }
const _hoisted_52 = { class: "d-none t-d-md-table-cell" }
const _hoisted_53 = { class: "d-none t-d-md-table-cell" }
const _hoisted_54 = { class: "d-none t-d-md-table-cell" }
const _hoisted_55 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_56 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_57 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_58 = { class: "col-md-6 col-sm-12" }
const _hoisted_59 = { class: "area-info" }
const _hoisted_60 = { class: "col-md-6 col-sm-12" }
const _hoisted_61 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_jw_pager = _resolveComponent("jw-pager")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!
  const _component_StockExitModal = _resolveComponent("StockExitModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode("  " + _toDisplayString(_ctx.language.stock_exit), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm",
                    placeholder: _ctx.language.search.toLowerCase(),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemSearchKey) = $event))
                  }, null, 8, _hoisted_8), [
                    [_vModelText, _ctx.itemSearchKey]
                  ])
                ])
              ])
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.language.stock_exit_msg), 1),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.language.stock_exit), 1),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddOperation(0, null)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.new), 1)
                  ]),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    disabled: _ctx.listOfStockExits.length == 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printListItems()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'print'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.print), 1)
                  ], 8, _hoisted_14),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refreshList()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'refresh'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.refresh), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_15, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("span", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.language.stock_exit), 1)
                    ]),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.language.name), 1)
                  ]),
                  _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.language.oper_date), 1),
                  _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.language.oper_type), 1),
                  _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.language.customer), 1),
                  _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.language.staff), 1),
                  _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.language.qty), 1),
                  _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.language.price), 1),
                  _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.language.total), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.listOfStockExits.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                      _createElementVNode("td", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.language.no_rec_fnd), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemPageElts, (recProduct) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "acct-cal-verified",
                    key: recProduct.IdStockExit
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_29, [
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.showAddOperation(1, recProduct))
                        }, _toDisplayString(_ctx.getProdName(recProduct)), 9, _hoisted_30),
                        _createTextVNode("  "),
                        _createVNode(_component_RouterLink, {
                          to: `/app/products/products/editor/${recProduct.ProductSku}`,
                          title: _ctx.language.view_product_detail
                        }, {
                          default: _withCtx(() => [
                            _hoisted_31
                          ]),
                          _: 2
                        }, 1032, ["to", "title"])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.language.name) + ": ", 1),
                          _createTextVNode("  "),
                          _createElementVNode("a", {
                            href: "javascript:;",
                            onClick: ($event: any) => (_ctx.showAddOperation(1, recProduct))
                          }, _toDisplayString(_ctx.getProdName(recProduct)), 9, _hoisted_35),
                          _createTextVNode("  "),
                          _createVNode(_component_RouterLink, {
                            to: `/app/products/products/editor/${recProduct.ProductSku}`,
                            title: _ctx.language.view_product_detail
                          }, {
                            default: _withCtx(() => [
                              _hoisted_36
                            ]),
                            _: 2
                          }, 1032, ["to", "title"])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.language.oper_date) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatDate(recProduct.ExitDate, 'DD/MM/YYYY HH:mm')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.language.oper_type) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getOperType(recProduct)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.language.customer) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getCustomerName(recProduct)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.language.staff) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getStaffName(recProduct)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.language.qty) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatNumbers(recProduct.Quantity)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.language.price) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(recProduct.Price)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.language.total) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.getTotalTransact(recProduct))), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.appFxs.formatDate(recProduct.ExitDate, 'DD/MM/YYYY HH:mm')), 1),
                    _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.getOperType(recProduct)), 1),
                    _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.getCustomerName(recProduct)), 1),
                    _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.getStaffName(recProduct)), 1),
                    _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.appFxs.formatNumbers(recProduct.Quantity)), 1),
                    _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(recProduct.Price)), 1),
                    _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(recProduct.TotalPrice)), 1)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["row margin-to-15", {'d-none': _ctx.listOfStockExits.length==0}])
            }, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createTextVNode(_toDisplayString(_ctx.language.total_entries) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.listOfStockExits.length), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("nav", _hoisted_61, [
                  _createVNode(_component_jw_pager, {
                    items: _ctx.filteredItems,
                    initialPage: 1,
                    pageSize: _ctx.itemsPerPage,
                    maxPages: 10,
                    onChangePage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPageChange($event)))
                  }, null, 8, ["items", "pageSize"])
                ])
              ])
            ], 2)
          ])
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_printer_dialog, {
        visible: _ctx.isPrintvisible,
        onCloseForm: _ctx.onPrintClose,
        printBaseData: _ctx.printInitialValues,
        extraPrintData: _ctx.printExtraData
      }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"]),
      _createVNode(_component_StockExitModal, {
        visible: _ctx.isExitModal,
        initialValues: _ctx.exitRecord,
        recordStatus: _ctx.recordStatus,
        listProducts: _ctx.lstOfProducts,
        listVariants: _ctx.lstOfVariantDetails,
        onCloseForm: _ctx.onDetailClose
      }, null, 8, ["visible", "initialValues", "recordStatus", "listProducts", "listVariants", "onCloseForm"])
    ]))
  ], 64))
}